// components/CryptoDetail.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

const CryptoDetail = ({ crypto, position}) =>{
  const apiURL = import.meta.env.VITE_API_URL; 
  const [chartData, setChartData] = useState(null);
  const [loadingChart, setLoadingChart] = useState(true);

  useEffect(() => {
    fetchChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crypto]);

  const fetchChartData = async () => {
	 const cryptoId = crypto.id; 
	 console.log("checking crypto id"); 
	 console.log(cryptoId); 
    try {
      const response = await axios.get(
        `${apiURL}/api/coingecko/metrics/${cryptoId}`,
      );
      const prices = response.data.prices;
      setChartData({
        labels: prices.map((price) => {
          const date = new Date(price[0]);
          return `${date.getMonth() + 1}/${date.getDate()}`;
        }),
        dataset:[
          {
            label: 'Price (USD)',
            data: prices.map((price) => price[1]),
            fill: false,
            borderColor: '#4ade80',
            tension: 0.1,
          },
        ],
      });
      setLoadingChart(false);
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setLoadingChart(false);
    }
  };

  return (
    <div className ="fixed inset-0 flex items-center justify-center bg-gray-200 relative">
		<div className ="bg-white absolute inset-0">
      <div className="flex items-center mb-4  bg-blue-500 text-white p-4 rounded z-50  p-6 rounded-lg shadow-lg ">
        <img src={crypto.image} alt={crypto.name} className="w-10 h-10 mr-4" />
        <div>
          <h3 className="text-xl font-semibold">{crypto.name} ({crypto.symbol.toUpperCase()})</h3>
          <p className="text-white">${crypto.current_price.toLocaleString()}</p>
        </div>
      </div>
      <div className = "bg-white">
        {loadingChart ? (
          <div className="flex justify-center items-center h-32 bg-white p-6 rounded-lg shadow-lg ">
            <p>Loading chart...</p>
          </div>
        ) : (
          <Line data={chartData} />
        )}
      </div>
    </div>
  </div>
  );
}
export default CryptoDetail; 
